module.exports = __webpack_public_path__ + "static/img/brees-2012-top.6bb1460.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2012-top.jpg
// module id = Dgmj
// module chunks = 1